export default __webpack_public_path__ + "static/media/chevronUpWhite.584614bf.svg";